import type { AuditLog } from '#dn-types/audit-log.ts';
import { useActorNoun, useCapitalizedTargetTypeNoun, useEventTypeVerb } from '../../type-string-maps.ts';

type Props = {
  log: AuditLog;
};

/** "Sentence" formatted log description */
export function AuditLogDescription({ log }: Props) {
  const targetNoun = useCapitalizedTargetTypeNoun(log.target.type);
  const eventVerb = useEventTypeVerb(log.event.type);
  const actorNoun = useActorNoun(log);

  // Special case for authentication messages
  if (log.event.type === 'SUCCEEDED_AUTH' || log.event.type === 'FAILED_AUTH') {
    const authMethod =
      log.target.type === 'oidcProvider' ? 'SSO'
      : log.target.type === 'endpointOIDC' ? 'endpoint SSO'
      : 'TOTP';
    return (
      <span>
        {actorNoun} {eventVerb} using {authMethod}
      </span>
    );
  }

  return <span>{`${targetNoun} ${eventVerb}${actorNoun ? ` by ${actorNoun}` : ''}`}</span>;
}
